/* eslint-disable jsdoc/newline-after-description */
import { DatePipe } from '@angular/common';
import {provideClientHydration} from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from 'src/app/layout/layout.module';
import { AppInitService } from 'src/app/services/util/app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { ToastrModule } from 'ngx-toastr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { RxStompService } from '@stomp/ng2-stompjs';
import { ToastrTemplatesModule } from './components/toastr-templates/toastr-templates.module';
import { AutomaticLogoutPopupModule } from './components/automatic-logout-popup/automatic-logout-popup.module';


export function appInit(appInitService: AppInitService): () => Promise<any> {
  return (): Promise<any> => appInitService.init().toPromise();
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        TranslocoRootModule,
        AutomaticLogoutPopupModule,
        LayoutModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-center',
        }),
        MatDatepickerModule,
        MatMomentDateModule,
        ToastrTemplatesModule], providers: [
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: {
                strict: true,
            },
        },
        DatePipe,
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            deps: [AppInitService],
            multi: true
        },
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS,
            useValue: {
                disabled: true,
            }
        },
        {
            provide: MAT_CHIPS_DEFAULT_OPTIONS,
            useValue: {
                separatorKeyCodes: [ENTER, COMMA]
            }
        },
        {
            provide: RxStompService,
        },
        provideClientHydration(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
